<template>
    <el-dialog title="充值记录" :visible="true" append-to-body width="80%" @close="close">
    
        <el-table :data="recordData" fit border stripe style="width: 100%" :loading="loading">
            <el-table-column prop="create_time" label="发起时间" ></el-table-column>
            <el-table-column prop="pay_time" label="付款时间" ></el-table-column>
            <el-table-column prop="payment_amount" label="支付金额" ></el-table-column>
            <el-table-column prop="recharge_amount" label="充值金额" ></el-table-column>

            <el-table-column prop="payment_status" label="支付状态" >
                <template #default="scope">
                    <template v-if="scope.row.payment_status == 1">
                        <el-tag class="ml-2" type="succes">已支付</el-tag>
                    </template>
                    <template v-else>
                        <el-tag class="ml-2" type="danger">未支付</el-tag>
                    </template>
                </template>
            </el-table-column>

            <el-table-column prop="payment_transaction" label="支付流水号" ></el-table-column>
            
        </el-table>

        <el-pagination
            style="text-align:right"
            background
            layout="prev, pager, next"
            :total="pagination.total"
            :page-size="pagination.size"
            :current-page="pagination.page"
            class="mt-4"
            @current-change="pageRecharge"
        />
    </el-dialog>
</template>
<script>

export default {
    components: {
        
    },
    data() {
        return {
            pagination: {
                total: 0,
                size: 10,
                page: 1,
            },
            recordData: [],
            loading: false
        }
    },
    mounted() {
      this.pageRecharge(1);  
    },
    methods: {
        close() {
            this.$emit('close');
        },
        pageRecharge(currPage) {
            this.loading = true;
            this.$API.pageRecharge({size: this.pagination.size, page: currPage}).then((response) => {
                if (response.code == 0 || response.code == 1000) {

                    this.recordData = response.data.list;
                    this.pagination.total = response.data.pagination.total;
                    this.pagination.page = response.data.pagination.page;
                    this.pagination.size = response.data.pagination.size;

                } else {
                    Elmessage.error(response.message);
                }

                this.loading = false;
            }).catch(err => {
                this.loading = false;
            });
        },
    }
}
</script>
<style scoped lang="scss">
</style>